export class TranslatedText {
  public de: string;
  public en: string;

  public static createEmptyInstance(): TranslatedText {
    const translatedText: TranslatedText = new TranslatedText();
    translatedText.de = '';
    translatedText.en = '';

    return translatedText;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/translated-text.ts